// extracted by mini-css-extract-plugin
export var colorSquare = "_tx-0";
export var danger = "_tx-5";
export var lightPink = "_tx-8";
export var neutralBlue = "_tx-7";
export var neutralYellow = "_tx-6";
export var normal = "_tx-1";
export var primary = "_tx-2";
export var primaryLight = "_tx-3";
export var solidBlack = "_tx-g";
export var solidGreen = "_tx-b";
export var solidLightBlue = "_tx-d";
export var solidNavy = "_tx-c";
export var solidOrange = "_tx-f";
export var solidPink = "_tx-e";
export var solidRed = "_tx-9";
export var solidYellow = "_tx-a";
export var success = "_tx-4";